export default __webpack_public_path__ + "static/media/portfolio-215.fbeb8097.jpg";